import request from "./request";
import * as qiniu from "qiniu-js";
import config from "../configs";


export async function upload(file: File, key: string, onProgress?: (progress: number) => void, putExtra: any = {}, config: any = {}) {
    const response = await request.get("/qiniu/token/")
    const token = response.data.data

    await new Promise((resolve, reject) => {
        const observable = qiniu.upload(file, key, token, putExtra, config)
        const observer = {
            next(res: any) {
                onProgress && onProgress(res.total.percent)
            },
            error(err: any) {
                reject(err)
            },
            complete(res: any) {
                resolve(res)
            }
        }
        observable.subscribe(observer)
    })
    return key
}


export async function remove(key: string) {
    await request.delete('/qiniu/delete', {
        params: {key}
    })
}

export function getUrl(key: string) {
    return `${config.QINIU_HOST}${key}`
}